
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/help/contact",
      function () {
        return require("private-next-pages/[locale]/help/contact.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/help/contact"])
      });
    }
  